import { useEffect, useState, PureComponent } from 'react'
import api from '../components/api'
import { fmtMes } from '../components/generalFunctions'
import moment from 'moment'

import { LineChart, Line, CartesianGrid, XAxis, YAxis, Tooltip, ResponsiveContainer, TooltipProps } from 'recharts';

interface CustomizedLabelProps {
    x?: number;
    y?: number;
    stroke?: string;
    value?: number | string;
  }


  const CustomTooltip = ({ active, payload, label }: TooltipProps<any, any>) => {
    if (active && payload && payload.length) {
      return (
        <div className="custom-tooltip">
          <div style={{ textAlign: 'left' }}>
            <span style={{ color: payload[0].stroke }}>
              {`${label}/${payload[0].payload.ano1}: R$ ${payload[0].payload.totalAno1.toLocaleString('pt-BR')}`}
            </span>
            <div style={{ marginBottom: 5 }} />
            <span style={{ color: payload[1].stroke }}>
              {`${label}/${payload[0].payload.ano2}: R$ ${payload[0].payload.totalAno2.toLocaleString('pt-BR')}`}
            </span>
          </div>
        </div>
      );
    }
  
    return null;
  };

  class CustomizedLabel extends PureComponent<CustomizedLabelProps> {
    render() {
      const { x, y, stroke, value } = this.props;
  
      return (
        <text
          x={x}
          y={y}
          dy={-4}
          fill={stroke}
          fontSize={10}
          textAnchor="middle"
        >
          {value}
        </text>
      );
    }
  }





interface iClientes {

    cliente_id: number,
    nomeFantasia: string,
    cnpj: string,


}


type DataChart = {
    mes: number;
    ano1: number;
    ano2: number;
    totalAno1: number;
    totalAno2: number;
  };



const DashboardFinanceiro = () => {

    var anoAtual = moment().format('YYYY')

    const [dataChart, setDataChart] = useState<DataChart[]>([]);


    const [cliente_id, setCliente_id] = useState<number | undefined>()
    const [clientes, setClientes] = useState<[]>([])
    const [ano, setAno] = useState<number | undefined>(Number(moment().year()))

    const [mes, setMes] = useState<number | undefined>();

    const [listaAnos, setListaAnos] = useState<number[]>([]);
    const [listaMeses, setListaMeses] = useState<number[]>([]);
    
    const dadosUsuarios = sessionStorage.getItem('dadosUsuarios')

    const [usuario_id, setUsuario_id] = useState<number | undefined>()


    const gerarDataChart = () => {
        const dados = Array.from({ length: 12 }, (_, i) => ({
          mes: i + 1,
          ano1: 2024,
          ano2: 2025,
          totalAno1: Math.floor(Math.random() * 10000),
          totalAno2: Math.floor(Math.random() * 10000),
        }));
      
        setDataChart(dados);
      };

    useEffect(() => {
        



        gerarDataChart()


    }, [cliente_id, ano, mes])


    useEffect(() => {

		if (dadosUsuarios) {

			var dados = JSON.parse(dadosUsuarios)

            console.log(dados)
            
            setClientes(dados.clientes)            
            setUsuario_id(dados.usuario_id)
            setCliente_id(dados.clientes.length == 1 ? dados.clientes[0].cliente_id : undefined)
		    //setCliente_id(dados.cliente_id ? Number(dados.cliente_id) : undefined)
	

		}

	}, [dadosUsuarios])



    function carregaAnos() {

        const x_array: number[] = [];
        
        for (let x = 2025; x <= parseInt(anoAtual); x++) {
            x_array.push(x);
        }
        
        setListaAnos(x_array.sort().reverse());
    }


    function carregaMeses() {

        const x_array: number[] = [];
        
        for (let x = 1; x <= 12; x++) {
            x_array.push(x);
        }
        
        setListaMeses(x_array);
    }

    useEffect(() => {

        carregaAnos()
        carregaMeses()
                
    }, [])




    return (
        <div>
            <div className="row g-3">
                <div className="col-md-4">
                    
                    <select  className="form-control" style={{ backgroundColor: '#f4f2ff'}}  value={ano} onChange={event => setAno(event.target.value ? Number(event.target.value) : undefined)}>
                        <option value="">[Ano]</option>
                        {listaAnos.map((rs) => 
                        
                            <option key={rs} value={rs}>{rs}</option>
                    
                        )}

                    </select>
                </div>
                <div className="col-md-4">
                    
                    <select  className="form-control"  style={{ backgroundColor: '#f4f2ff'}}  value={mes} onChange={event => setMes(event.target.value ? Number(event.target.value) : undefined)}>
                        <option value="">[Mês]</option>
                        {listaMeses.map((rs) =>
                        
                            <option key={rs} value={rs}>{fmtMes(rs)}</option>

                        )}

                    </select>
                </div>
                <div className="col-md-4">
                    
                    <select className="form-control" disabled={ clientes.length > 1 ? false : true } onChange={event => setCliente_id(event.target.value ? Number(event.target.value) : undefined)}  style={{ backgroundColor: '#f4f2ff'}}>
                    { clientes.length > 1 && ( <option value="">[Afiançadora]</option> )}
                    
                    {

                        clientes.map((rs: iClientes) => 
                            
                            <option value={rs.cliente_id}>{rs.cnpj} - {rs.nomeFantasia}</option>
                        )

                    }

                    </select>
                </div>
                <div className="col-md-12">

                    <ResponsiveContainer width="100%" height={200}>

                                                        

                        <LineChart data={dataChart} margin={{ top: 5, right: 20, bottom: 5, left: 0 } }>
                            <Line type="monotone" dataKey="totalAno1" stroke="#8884d8" label={<CustomizedLabel />} />
                            <Line type="monotone" dataKey="totalAno2" stroke="#bf714b" label={<CustomizedLabel />} />
                            

                            <CartesianGrid stroke="#ccc" strokeDasharray="5 5" />
                            <XAxis dataKey="mes" style={{ fontSize: '11px', fontFamily: 'Arial' }}
                            
                            
                            />
                            <YAxis 
                            tickFormatter={(value) =>
                                new Intl.NumberFormat("pt-BR", {
                                notation: "compact",
                                compactDisplay: "short",
                                }).format(value)}
                            style={{ fontSize: '10px', fontFamily: 'Arial' }}  />
                            
                            
                            
                            <Tooltip content={<CustomTooltip />} cursor={{ fill: "transparent" }} />
                        </LineChart>




                    </ResponsiveContainer>

                </div>
                        
            </div>
        </div>
    )
}

export default DashboardFinanceiro